import { setOccupancyLimits } from './folks-selector.js'
import { confirm } from "./popups.js"

// Shared pickers funcs
const $pickerBlock = $('#form-searchblock');
let availableDates;

function updateOccupancyLimits(response) {
	const { MinOccupancy, MaxOccupancy, AbsoluteMaxChildOccupancy } = response;

	setOccupancyLimits(MinOccupancy, MaxOccupancy, AbsoluteMaxChildOccupancy);
}

function makeAvailableDates(Departing) {
	const dates = [];
	for (let i = 0; i < Departing.length; i++) {
		const d = new Date(Departing[i]).getTime();
		dates.push(d);
	}

	return dates;
}

function checkAvailableDate(date) {
	let ret = [true, "", ""];
	if ($.inArray(date.getTime(), availableDates) === -1) {
		ret[0] = false;
		ret[1] = ""; // Custom disabled CSS class
		ret[2] = "Date not available"; // Custom message
	}

	return ret;
}

function updateDurationOptions(durationSelect, response) {
	durationSelect.find("option").each(function() {
		const option = $(this);
		if (option.val() === '' || $.inArray(parseInt(option.val()), response.Durations) > -1) {
			option.show();
		} else {
			option.hide();
		}
	});
}

const setSearchBarMessageDisplay = function(response) {
	if (response.message) {
		$pickerBlock.find('.js-search-bar-message-text').text(response.message);
		$pickerBlock.find('.js-search-bar-message').addClass('is-active');
		return;
	}

	$pickerBlock.find('.js-search-bar-message').removeClass('is-active');
}

const getSearchBarMessage = function(destinationId) {
	if (!destinationId) {
		return false;
	}

	$.ajax({
		url: "/SearchBarMessage/Get?destinationId=" + destinationId,
		success: function(response) {
			setSearchBarMessageDisplay(response);
		},
		error: function(e) {
			console.log(e);
		}
	});
}

const getSearchBarOptions = function() {
	const loader = $pickerBlock.find(".js-loader");
	loader.show();

	const departing = $pickerBlock.find('input[name="departuredateuk"]');
	const duration = $pickerBlock.find('input[name="nights"]');
	const formData = $pickerBlock.find('input, select').serialize();

	const request = $.ajax({
		url: "/api/search-block-options",
		data: formData,
		success: function(response) {
			response = JSON.parse(response);

			setSearchModuleOptions({
				response,
				dateField: departing,
				durationSelect: duration,
				enable: true,
			});

			// remove loader
			loader.hide();
		},
		error: function(e) {
			if (e.statusText !== "abort") {
				confirm("Error", "Sorry, there was an error (" + e.statusText.toLowerCase() + ").", "", true);
				console.log('getSearchBarOptions fail', e)
			}
			// remove loader
			loader.hide();
		}
	});

	const searchParams = new URLSearchParams(formData)
	getSearchBarMessage(searchParams.get("destination"));
}

const setSearchModuleOptions = function({ response, dateField, durationSelect, enable }) {

	if (response.Success) {
		updateOccupancyLimits(response);

		availableDates = makeAvailableDates(response.Departing);
		dateField.datepicker("option", "beforeShowDay", checkAvailableDate);

		window.site.body.trigger({
			type: "availableDatesLoaded",
			availableDates
		});

		updateDurationOptions(durationSelect, response);

		if (enable) {
			dateField.removeAttr("disabled");
		}

		requestAnimationFrame(() => {
			window.site.doc.trigger({
				type: "searchOptionsReceived",
				options: response
			});
		});

	}
	else {
		confirm("Error", "Sorry, there was an error (no dates found). Please try again.", "", true);
		console.log('setSearchModuleOptions dates error', e)
	}
}

export { getSearchBarOptions }
